import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { DataLineageQuery, DataLineageState, DataLineageStore } from '../../state/data-lineage';

@Injectable({ providedIn: 'root' })
export class DataLineageUserDataService extends AbstractUserRelatedDataService<DataLineageState> {
  constructor(readonly http: HttpClient, readonly store: DataLineageStore, readonly query: DataLineageQuery) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'data-lineage-lastseen',
        starred: 'data-lineage-starred',
      },
    });
  }
}
